import { Button } from "react-bootstrap";
import styles from "./index.module.scss";

const Item = ({ userId, comment, onDelete, isDeleting }) => {
  return (
    <div className={styles.item}>
      <div className={styles.itemInfo}>
        <div className={styles.userId}>{userId}</div>
        {comment && <div className={styles.comment}>{comment}</div>}
      </div>
      <Button
        className={styles.deleteButton}
        variant="outline-danger"
        aria-label={`Видалити користувача ${userId} з White List`}
        disabled={isDeleting}
        onClick={() => onDelete(userId)}
      >
        {isDeleting ? (
          <>
            <span
              className="spinner-border spinner-border-sm"
              aria-hidden="true"
            />
            <span>Видалення...</span>
          </>
        ) : (
          <>
            <i className="bi bi-trash" aria-hidden="true" />
            <span>Видалити</span>
          </>
        )}
      </Button>
    </div>
  );
};

export default Item;
